var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fa-icon',{staticClass:"icon-yeti",attrs:{"icon":"exclamation","transform":"shrink-6 rotate-45","mask":"square","fixed-width":_vm.fixedWidth}})
}
var staticRenderFns = []

export { render, staticRenderFns }